import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Users")
const _hoisted_2 = /*#__PURE__*/_createVNode("span", null, "Subjects", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("All subjects")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("HiPAL Pro")
const _hoisted_5 = { class: "header-text-place" }
const _hoisted_6 = { class: "header-login-place" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoIcon = _resolveComponent("LogoIcon")
  const _component_LogoMiniIcon = _resolveComponent("LogoMiniIcon")
  const _component_el_container = _resolveComponent("el-container")
  const _component_CorporateFareIcon = _resolveComponent("CorporateFareIcon")
  const _component_el_menu_item = _resolveComponent("el-menu-item")
  const _component_GroupIcon = _resolveComponent("GroupIcon")
  const _component_AssignmentIcon = _resolveComponent("AssignmentIcon")
  const _component_el_submenu = _resolveComponent("el-submenu")
  const _component_el_menu = _resolveComponent("el-menu")
  const _component_el_aside = _resolveComponent("el-aside")
  const _component_MenuIcon = _resolveComponent("MenuIcon")
  const _component_BreadCrumbs = _resolveComponent("BreadCrumbs")
  const _component_NotificationsIcon = _resolveComponent("NotificationsIcon")
  const _component_LoginComponent = _resolveComponent("LoginComponent")
  const _component_el_header = _resolveComponent("el-header")
  const _component_router_view = _resolveComponent("router-view")
  const _component_el_main = _resolveComponent("el-main")
  const _component_ErrorScreen = _resolveComponent("ErrorScreen")

  return (_openBlock(), _createBlock(_component_el_container, { class: "main-container" }, {
    default: _withCtx(() => [
      (_ctx.isAuth)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_el_aside, {
              width: _ctx.state.leftIsCollapse ? '72px' : '264px'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_container, {
                  class: ["logo-container", { 'is-collapsed': _ctx.state.leftIsCollapse }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_LogoIcon, { class: "logo-full" }),
                    _createVNode(_component_LogoMiniIcon, { class: "logo-mini" })
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_el_menu, {
                  class: "main-menu",
                  router: true,
                  collapse: _ctx.state.leftIsCollapse,
                  "default-openeds": ['/subjects'],
                  "default-active": _ctx.currentActivePath,
                  "collapse-transition": false
                }, {
                  default: _withCtx(() => [
                    (_ctx.showLink('/sites'))
                      ? (_openBlock(), _createBlock(_component_el_menu_item, {
                          key: 0,
                          index: "/sites",
                          "data-e2e": "sites"
                        }, {
                          title: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.hasRole(_ctx.UserRole.SystemAdmin) ? "Sites" : "My Site"), 1)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_CorporateFareIcon)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.showLink('/users'))
                      ? (_openBlock(), _createBlock(_component_el_menu_item, {
                          key: 1,
                          index: "/users",
                          "data-e2e": "users"
                        }, {
                          title: _withCtx(() => [
                            _hoisted_1
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_GroupIcon)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.showLink('/subjects'))
                      ? (_openBlock(), _createBlock(_component_el_submenu, {
                          key: 2,
                          index: "/subjects",
                          "popper-class": "subject-sub-menu",
                          "data-e2e": "subjects"
                        }, {
                          title: _withCtx(() => [
                            _createVNode(_component_AssignmentIcon),
                            _hoisted_2
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_menu_item, {
                              index: "/subjects",
                              "data-e2e": "all-subjects"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_3
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_menu_item, {
                              index: "/subjects/hipal-pro",
                              "data-e2e": "hipal-pro"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_4
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["collapse", "default-active"])
              ]),
              _: 1
            }, 8, ["width"]),
            _createVNode(_component_el_container, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_header, { height: "72px" }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_5, [
                      _createVNode(_component_MenuIcon, { onClick: _ctx.toggleMenu }, null, 8, ["onClick"]),
                      _createVNode(_component_BreadCrumbs)
                    ]),
                    _createVNode("div", _hoisted_6, [
                      _createVNode(_component_NotificationsIcon, { class: "notification-icon" }),
                      _createVNode(_component_LoginComponent)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_main, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_view)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 64))
        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            (_ctx.error)
              ? (_openBlock(), _createBlock(_component_ErrorScreen, { key: 0 }))
              : _createCommentVNode("", true)
          ], 64))
    ]),
    _: 1
  }))
}